import { render, staticRenderFns } from "./HyundaiIoniq5Disclosure.vue?vue&type=template&id=784262d1&"
import script from "./HyundaiIoniq5Disclosure.vue?vue&type=script&lang=js&"
export * from "./HyundaiIoniq5Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports